import React, { CSSProperties, ReactElement } from 'react'
import { jumpTo, RouterType } from '@/common/utils'
import './index.css'
import { classNames } from '@/common/utils/classNames'

interface Props {
  title?: string // 标题居中
  rightComponent?: ReactElement // 右部元素
  hideBackBtn?: boolean // 隐藏返回按钮
  leftTitle?: string // 标题居左
  customCallBack?: () => void // 自定义返回事件
  backgroundColor?: string // 背景色
  titleClassName?: string // 标题样式
  rightWrapperClassName?: string // 右部元素样式
  backButtonImage?: string // 返回按钮图片
  titleStyle?: CSSProperties
}

const NavigateBar = (props: Props) => {
  const { title, rightComponent, hideBackBtn, leftTitle, customCallBack, backgroundColor = '#ffffff', titleClassName, rightWrapperClassName, backButtonImage, titleStyle } = props

  const pop = () => {
    if (customCallBack) {
      customCallBack()
      return
    }
    jumpTo({ type: RouterType.BACK })
  }
  const STATUS_BAR_HEIGHT = Mach.env.statusBarHeight
  const NAVIGATION_BAR_HEIGHT = Mach.env.navigationBarHeight

  return (
    <view className="container" style={{ backgroundColor: backgroundColor }}>
      {/* 一定要加这一层 */}
      <view className="container-wrapper" style={{ height: STATUS_BAR_HEIGHT + NAVIGATION_BAR_HEIGHT }}>
        <view style={{ height: STATUS_BAR_HEIGHT }} />
        <view className="title-container-inner" style={{ height: NAVIGATION_BAR_HEIGHT }}>
          {!leftTitle && title && (
            <view className="title-text-wrapper">
              <text className={classNames('title', titleClassName)} style={titleStyle}>
                {title}
              </text>
            </view>
          )}
          {!hideBackBtn && (
            <view className="back-button-container" style={{ height: NAVIGATION_BAR_HEIGHT }} onClick={pop}>
              <image src={backButtonImage || 'assets://icon/common/page_back.png'} className="back-button" autoRTL />
            </view>
          )}
          {leftTitle && (
            <view className="left-title-container">
              <text className="title">{leftTitle}</text>
            </view>
          )}
          {rightComponent && <view className={classNames('right-wrapper', rightWrapperClassName)}>{rightComponent}</view>}
        </view>
      </view>
    </view>
  )
}

export default NavigateBar
